<div cdkDrag cdkDragRootElement=".modal-dialog">
<div class="modal-outer-body d-flex flex-column justify-content-between">
  <div class="modal-header d-flex flex-row justify-content-between" cdkDragHandle>
    <h5 class="modal-title">{{ title }}</h5>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="device">
    <!-- Tab Navigation -->
    <ul class="nav nav-tabs mb-3">
      <li class="nav-item">
        <a class="nav-link" [class.active]="activeTab === 'details'" (click)="setActiveTab('details')" style="cursor: pointer;">Details</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [class.active]="activeTab === 'raw'" (click)="setActiveTab('raw')" style="cursor: pointer;">Raw</a>
      </li>
    </ul>

    <!-- Details Tab -->
    <table *ngIf="activeTab === 'details'" class="table table-sm table-striped table-compact mb-2">
      <tbody>
        <tr>
          <th class="text-nowrap">ID</th>
          <td>{{ device.id }}</td>
        </tr>
        <tr>
          <th class="text-nowrap">Type</th>
          <td>{{ device.device_type }}</td>
        </tr>
        <tr *ngIf="device.latitude != null && device.longitude != null">
          <th class="text-nowrap">Location</th>
          <td>
            {{ device.latitude }}, {{ device.longitude }}
            <a *ngIf="googleMapsUrl" [href]="googleMapsUrl" target="_blank" rel="noopener" class="ml-2">Open in Google Maps</a>
          </td>
        </tr>
        <tr *ngIf="device.description">
          <th class="text-nowrap">Description</th>
          <td>{{ device.description }}</td>
        </tr>
        <tr>
          <th class="text-nowrap">Azimuth</th>
          <td><span *ngIf="azimuthText">{{ azimuthText }}&deg;</span></td>
        </tr>
        <tr>
          <th class="text-nowrap">Tilt</th>
          <td>{{ tiltText }}</td>
        </tr>
        <tr>
          <th class="text-nowrap">Height</th>
          <td>{{ device.height != null ? device.height + 'm' : '' }}</td>
        </tr>
        <tr>
          <th class="text-nowrap">Azimuth Beam Width</th>
          <td><span *ngIf="azimuthBeamWidthText">{{ azimuthBeamWidthText }}°</span></td>
        </tr>
        <tr>
          <th class="text-nowrap">Elevation Beam Width</th>
          <td><span *ngIf="elevationBeamWidthText">{{ elevationBeamWidthText }}°</span></td>
        </tr>
        <tr>
          <th class="text-nowrap">Range</th>
          <td><span *ngIf="rangeText">{{ rangeText }} m</span></td>
        </tr>
        <tr *ngIf="updatedAtText">
          <th class="text-nowrap">Updated</th>
          <td>{{ updatedAtText }}</td>
        </tr>
        <tr *ngIf="device.make || device.model">
          <th class="text-nowrap">Make/Model</th>
          <td>{{ device.make }}{{ device.make && device.model ? ' ' : ''}}{{ device.model }}</td>
        </tr>
        <tr *ngIf="device.building_id">
          <th class="text-nowrap">Building</th>
          <td>{{ device.building_id }}</td>
        </tr>
        <tr *ngIf="device.floor_name || device.floor_number !== undefined">
          <th class="text-nowrap">Floor</th>
          <td>{{ device.floor_name || ('#' + device.floor_number) }}</td>
        </tr>
      </tbody>
    </table>

    <!-- Raw Tab -->
    <div *ngIf="activeTab === 'raw'">
      <table class="table table-sm table-striped table-compact" *ngIf="rawDataEntries.length > 0">
        <tbody>
          <tr *ngFor="let entry of rawDataEntries">
            <th class="text-nowrap">{{entry.key}}</th>
            <td>{{entry.value}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer d-flex flex-row justify-content-end">
    <button class="btn btn-primary" (click)="close()">Close</button>
  </div>
</div>
</div>
